import { FileType as FileTypeService, questions as questionsService } from '@repo/customer-services';

export * from './api';
export * from './services';

export const FileType = FileTypeService;
export const questions = questionsService;
